import { render, staticRenderFns } from "./InventorySlotPrice.vue?vue&type=template&id=b56a565a&"
import script from "./InventorySlotPrice.vue?vue&type=script&lang=js&"
export * from "./InventorySlotPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports